import React from 'react'
import { Navbar1 } from '../navbar/Navbar'
import './news.css'
import Uploadnews from './Uploadnews';
import Newscard from './Newscard';

const useFetch = () => {
  const defaultValue = []
  const[data,setData] = React.useState(defaultValue)
  React.useEffect(() => {
      const getUsers = async function () {
          const respData = await (
              await fetch("https://api.github.com/users")
              ).json()
          setData(respData)
      }
      getUsers()
  }, [])
return data
}


export default function News() {
  const data = useFetch()
  return (
    <div className='fbnewscntr'>
      <Navbar1 />
      <div className='newscntr bor'>

        <Uploadnews />
        {/* <Newscard /> */}
        {data.map((user, index) => {
          return(
            <Newscard keys={user.id} image={user.avatar_url} name={user.login}/>
          )
        })}

      </div>
    </div>
  )
}
